"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Child = void 0;
/**
 * A child
 */
const address_1 = require("../value-objects/address");
const day_date_1 = require("../value-objects/day-date");
class Child {
    constructor(obj) {
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.birthDate = obj.birthDate ? new day_date_1.DayDate(obj.birthDate) : undefined;
        this.contactPeople = obj.contactPeople;
        this.gender = obj.gender;
        this.address = new address_1.Address(obj.address || {});
        this.email = obj.email ? obj.email.filter(email => !!email) : [];
        this.phone = obj.phone ? obj.phone.filter(phone => !!phone.phoneNumber) : [];
        this.remarks = obj.remarks;
        this.id = obj.id;
        this.managedByParents = obj.managedByParents;
        this.uitpasNumber = obj.uitpasNumber;
    }
    static sorted(list) {
        return [...list].sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
    static empty() {
        return new Child({
            contactPeople: [],
            firstName: "",
            lastName: "",
            remarks: "",
            address: {},
            phone: [],
            email: [],
        });
    }
    get fullName() { return `${this.firstName} ${this.lastName}`; }
    get primaryContactPerson() {
        return this.contactPeople[0];
    }
    withId(id) {
        return new Child(Object.assign(Object.assign({}, this), { id }));
    }
    withContactPeople(people) {
        return new Child(Object.assign(Object.assign({}, this), { contactPeople: people }));
    }
    withFirstName(firstName) {
        return new Child(Object.assign(Object.assign({}, this), { firstName }));
    }
    withLastName(lastName) {
        return new Child(Object.assign(Object.assign({}, this), { lastName }));
    }
    withBirthDate(date) {
        return new Child(Object.assign(Object.assign({}, this), { birthDate: new day_date_1.DayDate(date) }));
    }
    withGender(gender) {
        return new Child(Object.assign(Object.assign({}, this), { gender }));
    }
    withAddress(address) {
        return new Child(Object.assign(Object.assign({}, this), { address }));
    }
    withEmail(email) {
        return new Child(Object.assign(Object.assign({}, this), { email }));
    }
    withPhoneContact(phone) {
        return new Child(Object.assign(Object.assign({}, this), { phone }));
    }
    withRemarks(remarks) {
        return new Child(Object.assign(Object.assign({}, this), { remarks }));
    }
    withManagedByParents(parentUids) {
        return new Child(Object.assign(Object.assign({}, this), { managedByParents: parentUids }));
    }
    withUitpasNumber(uitpasNumber) {
        return new Child(Object.assign(Object.assign({}, this), { uitpasNumber }));
    }
}
exports.Child = Child;
//# sourceMappingURL=child.js.map